module.exports = __webpack_public_path__ + "static/media/ur20.feb4e16b.png";